import ScalarPopover_vue_vue_type_script_setup_true_lang_default from "./ScalarPopover.vue.script.js";
//#region src/components/ScalarPopover/ScalarPopover.vue
var ScalarPopover_default = ScalarPopover_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarPopover_default as default };

//# sourceMappingURL=ScalarPopover.vue.js.map